"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var fill_1 = tslib_1.__importDefault(require("lodash/fill"));
var helpers_1 = require("../../../chartTypes/_chartCreators/helpers");
// delete this plugin once we upgrade to newer highcharts,
// set allowOverlap: false to get this behaviour
var autohidePieLabels = function (chart) {
    var _a, _b;
    var visibleSeries = helpers_1.getVisibleSeries(chart);
    var visiblePoints = helpers_1.getDataPoints(visibleSeries);
    if (!visiblePoints || visiblePoints.length === 0) {
        return;
    }
    var visibilityMap = fill_1.default(Array(visiblePoints.length), true);
    for (var i = 0; i < visiblePoints.length; i++) {
        // TODO the as any cast is sketchy, but this is what was in the original lodash/get call
        var actualLabel = (_a = visiblePoints === null || visiblePoints === void 0 ? void 0 : visiblePoints[i]) === null || _a === void 0 ? void 0 : _a.dataLabel;
        // do nothing if label not found or already hidden
        if (!actualLabel || !visibilityMap[i]) {
            continue;
        }
        for (var neighborIdx = i + 1; neighborIdx < visiblePoints.length; neighborIdx++) {
            // TODO the as any cast is sketchy, but this is what was in the original lodash/get call
            var neighborLabel = (_b = visiblePoints === null || visiblePoints === void 0 ? void 0 : visiblePoints[neighborIdx]) === null || _b === void 0 ? void 0 : _b.dataLabel;
            // do nothing if label not found or already hidden
            if (!neighborLabel || !visibilityMap[neighborIdx]) {
                continue;
            }
            var intersects = helpers_1.isIntersecting(actualLabel, neighborLabel);
            if (!intersects) {
                neighborLabel.show();
            }
            else {
                visibilityMap[neighborIdx] = false;
                neighborLabel.hide();
            }
        }
    }
};
exports.default = autohidePieLabels;
//# sourceMappingURL=autohidePieLabels.js.map